import { addDays, isFuture } from 'date-fns'
import { isEmpty } from 'lodash-es'

const expirationWindow = 7
const storageKeyName = 'truckl'
const separator = '::'

const RememberMe = {
  /**
   * Places user credentials in a persistent storage to be used for automatically re-logging in the user
   *
   * @param {String} username
   * @param {String} password
   */
  storeCreds({ username, password }) {
    const splitEmail = username.split('@')
    const expiration = addDays(new Date(), expirationWindow)
    // lame attempt to make data a little less "guessable" for anyone snooping in localStorage
    const shuffledData = `${expiration}${separator}${splitEmail[0]}${separator}${password}${separator}${splitEmail[1]}`
    const payload = window.btoa(shuffledData)

    window.localStorage.setItem(storageKeyName, payload)
  },

  /**
   * Stored credentials
   *
   * @returns {Promise<{email: string, password: string}>}
   */
  async getCreds() {
    const storedCreds = window.localStorage.getItem(storageKeyName)

    if (isEmpty(storedCreds)) {
      return
    }

    const [expirationDate, user, password, domain] = window.atob(storedCreds).split(separator)
    // because we split the user email in to bits, it needs to be reassembled
    const username = `${user}@${domain}`

    if (isFuture(expirationDate)) {
      return { username, password }
    } else {
      window.localStorage.removeItem(storageKeyName)
    }
  }
}

export default RememberMe
